// Find static page content for page slug
const staticPageContent = (slug: string, data:Content) => {
    return data.pages.find(item => item.slug === slug);
};

export default staticPageContent
